import { Readable, derived, writable } from 'svelte/store';
import dayjs from 'dayjs';
import Duration from 'dayjs/plugin/duration';
import { gameInitParams } from '@root/src/store/misc';
import { STREAM_STATUSES } from '@src/constants';
import { availableBets, popularBetIndex, selectedBetAmount, selectedBetIndex } from './betting.js';
// feature game mechanics
import { GameResult, PlayResponse } from '@src/types';
import { GameStatus } from '@src/types/stringTypes';
import { GameStateType, gameStates } from '../states/machine/state-types.js';
import { getNormalizeNumberWithDecimals, getUrlParam } from '../utils/global';
import { chipTotalBet, isMaxedOut, totalBet } from './chips.js';

export { availableBets, selectedBetIndex, selectedBetAmount, popularBetIndex };

export const gameReady = writable(false);
// #BALANCE
export const unformattedBalance = writable(0);
export const balance = derived([unformattedBalance, gameInitParams], ([$unformattedBalance, $gameInitParams]) => {
    if (!$gameInitParams?.currency_attributes) return '';
    const { exponent, subunits } = $gameInitParams?.currency_attributes;
    return getNormalizeNumberWithDecimals($unformattedBalance, exponent, subunits);
});

export const currency = writable(getUrlParam('currency') || null);

// #VIDEO
export const videoState = writable(STREAM_STATUSES.UNKNOWN);
export const videoUrl = writable<string | null>(null);
export const videoHasBeenPlayed = writable(false);
export const videoAndGameSyncDelay = writable(null);
export const videosFiltered = writable(null);

// #BETTING
export const allowToBet = writable(false);
export const selectedMultiplier = writable(null);
export const autoBetStarted = writable(false);

export const autoBetCount = writable(0);
export const lastSelectedAutoBetCount = writable<number>(null);

export const isPlayAllowed = derived(
    [allowToBet, balance, totalBet, chipTotalBet],
    ([$allowToBet, $balance, $totalBet, $chipTotalBet]) => {
        return $allowToBet && parseFloat($balance) >= parseFloat($totalBet) && $chipTotalBet > 0;
    }
);

// #SKIP
export const allowToSkip = writable(false);
export const skipHappen = writable(false);

// #GAME ROUND
export const gameRoundInfo = writable<PlayResponse | null>(null);
export const gameId = writable<string | null>(null);
export const gameResult = writable<GameResult>(null);
export const gameStatus = writable<GameStatus>('NOT_STARTED');
export const gameState = writable<GameStateType>(null);
export const isLoading = derived(gameState, $gameState => $gameState === null || $gameState === gameStates.init);
export const isPlinko = derived(gameState, $gameState => $gameState === null || $gameState === gameStates.plinko);
export const isUndoResetHistory = writable(false);
export const roundTime = writable({ from: null, to: null });

export const hintStatus: Readable<string> = derived(
    [gameStatus, gameState, isMaxedOut],
    ([$gameStatus, $gameState, $isMaxedOut]) => {
        if ($gameState === gameStates.game && $gameStatus === 'PLACE_BET') return 'make your bets';

        if ($gameState === gameStates.game && $gameStatus === 'STARTED') return 'bets closed';

        return '';
    },
    ''
);

// #PLINKO
export const multipliers = writable('');

dayjs.extend(Duration);

export const stopAutoBet = () => {
    autoBetStarted.set(false);
    autoBetCount.set(0);
};
